function formatDateLLL(date) {
  const date_obj = new Date(date);

  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(date_obj);
}

export default formatDateLLL;

